var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('AnnotationLabel',{attrs:{"isIntro":_vm.isIntro,"stateAnnotations":_vm.stateAnnotations,"latestDistrictCode":_vm.latestDistrictCode,"numDistricts":_vm.numDistricts,"totalTimelineSpan":_vm.totalTimelineSpan}}),_vm._v(" "),(_vm.summaryText)?_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.summaryText))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09f997d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnnotationSummary.vue
// module id = null
// module chunks = 